import Vue from 'vue'
import VueRouter from 'vue-router'
import Attribute from '../views/Attribute.vue'
import Subject from '../views/Subject.vue'
import Favorite from '../views/Favorite.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Attribute
  },
  {
    path: '/subject',
    name: 'subject',
    component: Subject,
    props: true
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: Favorite,
    props: true
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  // 明示してpropが渡されていない場合、自コンポーネントが渡されたユーザ属性をそのまま渡す
  if (!to.params.user_attribute && from.params.user_attribute) {
    to.params.user_attribute = from.params.user_attribute
  }

  next()
})

export default router
